//Generating the Context with function
import createDataContext from './createDataContext';
import API from '../api/dhlApi';
import API_CATALOGS from '../api/dhlApiCatalogs';
import 'url-search-params-polyfill';
const MAX_RESERVATION_DATES = 4;
const ApiKey = process.env.REACT_APP_DHL_APP_KEY;
const DhlApiKey = process.env.REACT_APP_DHL_API_KEY;

// const ApiKey = 'c47WVQt9WbRsYng3neb7swvGqHMH0ytj6ANjXOQ4';
// const DhlApiKey = 'IYpZ6QeqkN9eANxoZjPGq2HINFCi9eH6';

//Map opening and closing variables to their day of the week
const openingVars = [
  'sunday_open',
  'monday_to_friday_open',
  'monday_to_friday_open',
  'monday_to_friday_open',
  'monday_to_friday_open',
  'monday_to_friday_open',
  'saturday_open',
];
const closingVars = [
  'sunday_close',
  'monday_to_friday_close',
  'monday_to_friday_close',
  'monday_to_friday_close',
  'monday_to_friday_close',
  'monday_to_friday_close',
  'saturday_close',
];
const FOOD_HOUR_START = 'food_start';
const FOOD_HOUR_END = 'food_end';
const INITIAL_STATE = {
  isLoading: true,
  errorMessage: '',
  token: null,
  awbCode: null,
  awbState: null,
  awb: null,
  station: null,
  stationHours: null,
  awbData: {},
  reservationTime: 'Horario',
  reservationDate: 'Fecha',
  debugText: '',
  availableTimes: [],
  availableDates: [],
};
const mainReducer = (state, action) => {
  switch (action.type) {
    case 'reset_initial_state':
      return INITIAL_STATE;
    case 'cra_login':
      return { ...state, token: action.payload };
    case 'cra_login_error':
      return { ...state, errorMessage: action.payload, isLoading: false };
    case 'set_awb_code':
      return { ...state, awbCode: action.payload };
    case 'set_awb_state':
      return { ...state, awbState: action.payload };
    case 'awb_state':
      return {
        ...state,
        awb: action.payload.pickupPackageCandidate,
        station: action.payload.location,
        stationHours: action.payload.locationOfficeHour,
        isLoading: false,
      };
    case 'awb_state_error':
      return { ...state, isLoading: false, errorMessage: action.payload };
    case 'set_reservation_time':
      return { ...state, reservationTime: action.payload };
    case 'set_reservation_date':
      return { ...state, reservationDate: action.payload };
    case 'set_debug_text':
      return { ...state, debugText: state.debugText + action.payload };
    case 'client_confirmation':
      return { ...state, isLoading: true };
    case 'client_confirmation_success':
      return { ...state, isLoading: false, awbState: 'CO' };
    case 'client_confirmation_error':
      return { ...state, isLoading: false, errorMessage: action.payload };
    case 'create_date_options':
      return { ...state, isLoading: false, availableDates: action.payload };
    case 'create_date_options_error':
      return {
        ...state,
        isLoading: false,
        errorMessage: 'Horarios no configurados',
      };
    case 'create_time_intervals':
      return { ...state, isLoading: false, availableTimes: action.payload };
    default:
      return state;
  }
};
const addDays = (date, days) => {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};
const getDatevalidation = (
  dateToValidate,
  stationHours,
  isCurrentDate,
  holidays
) => {
  var dayOfWeek = dateToValidate.getDay();
  var validDate = false;
  if (holidays != null) {

    const index = holidays.indexOf(
      dateToValidate.toLocaleDateString('en-GB').replace(/[^ -~]/g, '')
    );
    if (index !== -1) {
      return validDate;
    }
  }
  //Validating for configured time windows for current date
  if (
    stationHours[openingVars[dayOfWeek]] !== null &&
    stationHours[openingVars[dayOfWeek]] !== '00:00' &&
    stationHours[closingVars[dayOfWeek]] !== null &&
    stationHours[closingVars[dayOfWeek]] !== '00:00'
  ) {
    //Validating if cvurrent date and still in closing hours
    if (isCurrentDate) {
      var closeTimeArray = stationHours[closingVars[dayOfWeek]].split(':');
      var closeTime = new Date(Date.now());
      var closingTimeMinAdjustment = 30;
      closeTime.setHours(closeTimeArray[0]);
      closeTime.setMinutes(
        parseInt(closeTimeArray[1]) - closingTimeMinAdjustment,
        0,
        0
      );
      if (
        dateToValidate.toLocaleTimeString('en-GB') <
        closeTime.toLocaleTimeString('en-GB')
      ) {
        validDate = true;
      }
    } else {
      validDate = true;
    }
  }
  return validDate;
};
const getExpiringDatetime = (expiringDate) => {
  //Calculating expiring date
  var dateTimeArray = expiringDate.split('T');
  var dateArray = dateTimeArray[0].split('-');
  var timeArray = dateTimeArray[1].split('+')[0].split(':');
  var expiration = new Date(
    dateArray[0],
    dateArray[1] - 1,
    dateArray[2],
    timeArray[0],
    timeArray[1],
    0
  );
  return expiration;
};
const createDateOptions =
  (dispatch) => async (expiringDate, stationHours, station) => {
    try {
      var dateList = [];
      var isCurrentDate = true;
      var currentDatetime = new Date(Date.now());
      var holidays = [];
      holidays = await getHolidays(expiringDate, station);
      var expiringDatetime = getExpiringDatetime(expiringDate);
      while (dateList.length < MAX_RESERVATION_DATES) {
        //If current day exceedes expire dateList
        if (currentDatetime > expiringDatetime) {
          break;
        }
        //If current date is valid to add to the array
        if (
          getDatevalidation(
            currentDatetime,
            stationHours,
            isCurrentDate,
            holidays
          )
        ) {
          dateList.push(currentDatetime.toLocaleDateString('en-GB'));
        }
        currentDatetime = addDays(currentDatetime, 1);
        isCurrentDate = false;
      }
      dispatch({ type: 'create_date_options', payload: dateList });
    } catch (e) {
      console.log(e);
      dispatch({ type: 'create_date_options_error' });
    }
  };
const parseIntHelper = (stringTConvert) => {
  var removedNonPrintable = stringTConvert.replace(/[^ -~]/g, '');
  var newInt = parseInt(removedNonPrintable, 10);
  return newInt;
};
const getFoodHours = (stationHours) => {
  var foodHours = [];
  var startTimeArray = stationHours[FOOD_HOUR_START].split(':');
  var endTimeArray = stationHours[FOOD_HOUR_END].split(':');
  var startDateTime = new Date(
    2021,
    1,
    1,
    parseIntHelper(startTimeArray[0]),
    parseIntHelper(startTimeArray[1]),
    0
  );
  var endDateTime = new Date(
    2021,
    1,
    1,
    parseIntHelper(endTimeArray[0]),
    parseIntHelper(endTimeArray[1]),
    0
  );
  var max = (Math.abs(endDateTime - startDateTime) / (60 * 60 * 1000)) * 2;
  var time = new Date(startDateTime);
  for (var i = 0; i <= max; i++) {
    foodHours.push(time.toLocaleTimeString('en-GB'));
    time.setMinutes(time.getMinutes() + 30);
  }
  return foodHours;
};
const createHalfHourIntervals =
  (dispatch) => (reservationDate, stationHours) => {
    var timeList = [];
    if (stationHours[closingVars[1]]) {
      var currentDateTime = new Date(Date.now());
      var selectedDateArray = reservationDate.split('/');
      var selectedDate = new Date(
        parseIntHelper(selectedDateArray[2]),
        parseIntHelper(selectedDateArray[1]) - 1,
        parseIntHelper(selectedDateArray[0]),
        8,
        0,
        0
      );
      //Checking if selected
      var isSelectedCurrentDate =
        currentDateTime.toLocaleDateString('en-GB') ===
        selectedDate.toLocaleDateString('en-GB');
      var isDuringDayStartTime = false;
      var dayOfWeek = selectedDate.getDay();
      //Setting time intervals
      var startTime = stationHours[openingVars[dayOfWeek]];
      var endTime = stationHours[closingVars[dayOfWeek]];
      //Adjusting the opening time according to current time if current date is selected
      if (isSelectedCurrentDate) {
        //Creating a time for opening on selected Date
        var openingArray = stationHours[openingVars[dayOfWeek]].split(':');
        var openingDateTime = new Date(Date.now());
        openingDateTime.setHours(parseIntHelper(openingArray[0]));
        openingDateTime.setMinutes(parseIntHelper(openingArray[1]), 0, 0);
        //If station has not opened yet, then the opening time is selected, else the current time
        if (currentDateTime > openingDateTime) {
          isDuringDayStartTime = true;
          startTime = currentDateTime.toLocaleTimeString('en-GB');
        }
      }
      //Creating time arrays with selected elements
      var startTimeArray = startTime.split(':');
      var endTimeArray = endTime.split(':');
      var startDateTime = new Date(
        2021,
        1,
        1,
        parseIntHelper(startTimeArray[0]),
        parseIntHelper(startTimeArray[1]),
        0
      );
      var endDateTime = new Date(
        2021,
        1,
        1,
        parseIntHelper(endTimeArray[0]),
        parseIntHelper(endTimeArray[1]),
        0
      );
      if (endTimeArray[1] === '59') {
        endDateTime.setMinutes(endDateTime.getMinutes() + 1);
      }

      //Adjusting Endtime to 30 minutes before closing time
      endDateTime.setMinutes(endDateTime.getMinutes() - 30);
      //Adjusting starting time in current day
      if (isDuringDayStartTime) {
        startDateTime.setMinutes(startDateTime.getMinutes() + 30);
        var hours = startDateTime.getHours();
        var adjustment = startDateTime.getMinutes() / 30;
        if (adjustment > 1) {
          startDateTime.setHours(hours + 1);
          startDateTime.setMinutes(0, 0, 0);
        } else {
          startDateTime.setMinutes(30, 0, 0);
        }
      }
      var max = (Math.abs(endDateTime - startDateTime) / (60 * 60 * 1000)) * 2;
      var time = new Date(startDateTime);
      for (var i = 0; i <= max; i++) {
        timeList.push(time.toLocaleTimeString('en-GB'));
        time.setMinutes(time.getMinutes() + 30);
      }
      if (
        stationHours[FOOD_HOUR_START] !== null &&
        stationHours[FOOD_HOUR_END] !== null &&
        stationHours[FOOD_HOUR_START] !== '00:00' &&
        stationHours[FOOD_HOUR_END] !== '00:00'
      ) {
        var foodHours = getFoodHours(stationHours);
        foodHours.forEach((item, i) => {
          const index = timeList.indexOf(item);
          if (index > -1) {
            timeList.splice(index, 1);
          }
        });
      }
    }
    dispatch({ type: 'create_time_intervals', payload: timeList });
  };
const clientConfirmation = (dispatch) => async (id, retirievalDate) => {
  dispatch({ type: 'client_confirmation' });
  const url = 'operation/pickup/confirmation';
  const data = {
    packageCandidateId: id,
    pickupDate: retirievalDate,
  };
  const config = {
    headers: {
      AppKey: ApiKey,
      Accept: 'application/json',
      'content-type': 'application/x-www-form-urlencoded;charset=utf-8',
      'dhl-api-key': DhlApiKey
    },
  };
  await API.post(url, data, config)
    .then((response) => {
      if (response.data.status === 'success') {
        dispatch({ type: 'client_confirmation_success' });
      } else {
        dispatch({
          type: 'client_confirmation_error',
          payload: response.data.message,
        });
      }
    })
    .catch((err) => {
      console.log(err);
      dispatch({
        type: 'client_confirmation_error',
        payload: 'Falló consulta',
      });
    });
};
const awbState = (dispatch) => async (awbCode) => {
  const config = {
    headers: {
      AppKey: ApiKey,
     'dhl-api-key': DhlApiKey
    },
  };
  console.log(API);
  await API.get(`operation/pickup/package-candidate?urlCode=${awbCode}`, config)
    .then((response) => {
      if (response.data.status === 'success') {
        dispatch({ type: 'awb_state', payload: response.data.data });
      } else {
        dispatch({
          type: 'awb_state_error',
          payload: response.data.data.message,
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: 'awb_state_error',
        payload: 'Error en la consulta',
      });
    });
};
const getHolidays = async (expiringDate, station) => {
  var holidays = null;
  const config = {
    headers: {
      AppKey: ApiKey,
      'dhl-api-key': DhlApiKey
    },
  };
  var finalDate = expiringDate.split('T');
  var currentDatetime = new Date(Date.now()).toLocaleDateString('en-GB');
  var currentDatetimeArray = currentDatetime.split('/');
  await API_CATALOGS.get(
    `holidays/client?countryCode=MX&dateFrom=${
      currentDatetimeArray[2] +
      '-' +
      currentDatetimeArray[1] +
      '-' +
      currentDatetimeArray[0]
    }&dateTo=${finalDate[0]}&city=${station.city}`,
    config
  )
    .then((response) => {
      if (response.data.status === 'success') {
        holidays = response.data.data.holidays.map((item) => {
          var date = item.date.split('T');
          var dateArray = date[0].split('-');
          var newDate = dateArray[2] + '/' + dateArray[1] + '/' + dateArray[0];
          return newDate;
        });
      }
    })
    .catch((err) => {
      return null;
    });
  return holidays;
};
const setAwbCode = (dispatch) => (awbCode) => {
  dispatch({ type: 'set_awb_code', payload: awbCode });
};
const setAwbState = (dispatch) => (awbState) => {
  dispatch({ type: 'set_awb_state', payload: awbState });
};
const setAvailableTimes = (dispatch) => (availableTimes) => {
  dispatch({ type: 'set_available_times', payload: availableTimes });
};
const setAvailableDates = (dispatch) => (availableDates) => {
  dispatch({ type: 'set_available_dates', payload: availableDates });
};
const setReservationTime = (dispatch) => (reservationTime) => {
  dispatch({ type: 'set_reservation_time', payload: reservationTime });
};
const setReservationDate = (dispatch) => (reservationDate) => {
  dispatch({ type: 'set_reservation_date', payload: reservationDate });
};
const setDebugText = (dispatch) => (debugText) => {
  dispatch({ type: 'set_debug_text', payload: debugText });
};
export const { Context, Provider } = createDataContext(
  mainReducer,
  {
    awbState,
    clientConfirmation,
    createDateOptions,
    createHalfHourIntervals,
    setAwbCode,
    setAwbState,
    setDebugText,
    setAvailableTimes,
    setAvailableDates,
    setReservationTime,
    setReservationDate,
  },
  INITIAL_STATE
);
